import Alpine from "alpinejs";

// import CustomScrollbar from "./CustomScrollbar";
// Alpine.data("CustomScrollbar", CustomScrollbar);

import ContactsMap from "./ContactsMap";
Alpine.data("ContactsMap", ContactsMap);

import Accordion from "./Accordion";
Alpine.data("Accordion", Accordion);

import PhoneInputMask from "./PhoneInputMask";
Alpine.data("PhoneInputMask", PhoneInputMask);

import SimpleSlider from "./SimpleSlider";
Alpine.data("SimpleSlider", SimpleSlider);

import SidebarTitles from "./SidebarTitles";
Alpine.data("SidebarTitles", SidebarTitles);

import AnalyzesMenu from "./AnalyzesMenu";
Alpine.data("AnalyzesMenu", AnalyzesMenu);

import TimeInputMask from "./TimeInputMask";
Alpine.data("TimeInputMask", TimeInputMask);

import FancyboxGallery from "./FancyboxGallery";
Alpine.data("FancyboxGallery", FancyboxGallery);

import DateInputMask from "./DateInputMask"
Alpine.data("DateInputMask", DateInputMask)

import OpenModal from "./OpenModal"
Alpine.data("OpenModal", OpenModal)

Alpine.store("mainMenu", {
    open: false,
});

Alpine.store("sessid", window.sessid);

// Стор корзины — с䑺ётчик и сумма
const initCart = window.cartInitData || { count: 0, total: 0 };
Alpine.store("cart", {
    count: initCart.count,
    total: initCart.total,
    add(price) {
        this.count += 1;
        this.total += price;
    },
    remove(price) {
        this.count = Math.max(0, this.count - 1);
        this.total = Math.max(0, this.total - price);
    },
    set(count, total) {
        this.count = count;
        this.total = total;
    }
});

// Обновляем store после HTMX-запросов корзины
document.body.addEventListener('htmx:afterRequest', function(evt) {
    const xhr = evt.detail.xhr;
    const elt = evt.detail.elt;
    // Обрабатываем ответ от add_to_cart
    const action = elt.name === 'action' ? elt : elt.querySelector('[name="action"]');
    if (!action) return;
    try {
        const data = JSON.parse(xhr.responseText.trim());
        if (data.status === 'success' && data.cart) {
            Alpine.store('cart').set(data.cart.count, data.cart.total);
        }
    } catch (e) {}
});

Alpine.start();

// === Sticky header: класс scrolled при прокрутке ===
(function () {
    const header = document.querySelector('header');
    if (!header) return;

    // Устанавливаем CSS-переменную высоты хедера
    function updateHeaderHeight() {
        document.documentElement.style.setProperty(
            '--header-height',
            header.offsetHeight + 'px'
        );
    }
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    // IntersectionObserver: sentinel-элемент над хедером
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;height:1px;width:100%;pointer-events:none;';
    document.body.prepend(sentinel);

    const observer = new IntersectionObserver(
        ([entry]) => {
            header.classList.toggle('scrolled', !entry.isIntersecting);
            // обновляем высоту после компактного перехода
            setTimeout(updateHeaderHeight, 320);
        },
        { threshold: 0 }
    );
    observer.observe(sentinel);
})();
